<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="teacherSummary && teacherProgress">
			<title-bar title="Progreso" :percentage="teacherSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="teacherSummary.itemName" :percentage="teacherSummary.itemPercentage" percentageTitle="Promedio Docente" :academicLevelTitle="teacher.academicLevelName"/>
			<title-bar :title="category.name" :percentage="category.percentage" percentageTitle="Promedio Categoría" :categoryId="categoryId"/>
			<div class="col full">
				<div class="row between innerRubric">
					<progress-chart v-for="question in progressionReport.questions" :key="question.id" :categoryId="categoryId" :data="question.graphData" :title="question.name" :percentage="question.percentage"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['teacherPersonUuid', 'categoryId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		teacherSummary () {
			if (this.$store.state.teachers.summary) return this.$store.state.teachers.summary.find((item) => {
				return item.itemId == this.teacherPersonUuid;
			});
			return this.$store.state.teachers.summary;
		},
		teacherProgress () {
			if (this.$store.state.teachers.progress) return this.$store.state.teachers.progress.find((item) => {
				return item.teacher.teacherPersonUuid == this.teacherPersonUuid;
			}).progress;
			return this.$store.state.teachers.progress;
		},
		teacher () {
			if (this.$store.state.teachers.progress) return this.$store.state.teachers.progress.find((item) => {
				return item.teacher.teacherPersonUuid == this.teacherPersonUuid;
			}).teacher;
			else return this.$store.state.teachers.progress;
		},
		category () {
			if (this.teacherSummary) return this.teacherSummary.coachingCategories.find((category) => {
				return category.id == this.categoryId;
			});
			else return this.teacherSummary;
		},
		progressionReport () {
			if (!this.category) return [];
			this.category.questions.forEach((coachingQuestion) => {
				coachingQuestion.graphData = {
					labels: this.teacherProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == this.categoryId) {
								category.questions.forEach((question) => {
									if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
								});
							}
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.teacherProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == this.categoryId) {
									category.questions.forEach((question) => {
										if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
									});
								}
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.teacherProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
				return coachingQuestion;
			});
			return this.category;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/teachers/CategoryProgress.vue